import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusinessDetail } from 'src/app/entities/request';
import { KeyValueId, LocalService, TriggeredEvent } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-receipt-template-selector',
  templateUrl: './receipt-template-selector.component.html',
  styleUrl: './receipt-template-selector.component.scss'
})
export class ReceiptTemplateSelectorComponent {
  items: KeyValueId[] = []; receiptId: string = ''; isLoadTemplate = false; businessId: string = '';

  constructor(public localService: LocalService, private router: Router, private activeModal: NgbActiveModal, private printerService: PrinterService) { }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {
    if (this.isLoadTemplate) {
      const countryCode = this.localService.basicParams.countryCode.includes('-') ? this.localService.basicParams.countryCode.split('-')[1] : this.localService.basicParams.countryCode;
      const req = {
        BusinessId: this.businessId,
        CountryCode: countryCode
      } as BusinessDetail;
      this.printerService.getPrinterTemplates(req).subscribe(result => {
        const templates = result.filter(x => x.IsCustomerCopy == true);
        templates.forEach(template => {
          this.items.push({
            key: template.Key,
            value: template.Title
          });
        });
      });
    } else {
      this.onLoad();
    }
  }

  onLoad() {
    const customerTemplateIds = this.localService.getCustomerCopiesTemplateIds();
    customerTemplateIds.forEach(customerTemplateId => {
      const template = this.localService.loggedMember.receiptTemplates.find(x => x.id == customerTemplateId);

      if (template) {
        this.items.push({
          key: template.id,
          value: template.title
        });
      }
    });
  }

  onRoute(templateId: string) {
    const countryCode = this.localService.basicParams.countryCode.includes('-') ? this.localService.basicParams.countryCode.split('-')[1] : this.localService.basicParams.countryCode;

    this.router.navigate(['/rv/' + countryCode, templateId, this.receiptId]);
    this.onPopupClose();
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }
}
